import { Component } from '@angular/core';

@Component({
  selector: 'app-pipeline-status-info',
  templateUrl: './pipeline-status-info.component.html',
  styleUrl: './pipeline-status-info.component.scss',
  standalone: false,
})
export class PipelineStatusInfoComponent {}
